module.exports = __webpack_public_path__ + "static/media/dentistry.70ac5b43.svg";